// Mock financial data for the CFO-as-a-Service platform
// KPI Data
export const kpiData = [
  {
    id: 1,
    title: 'Ventas del mes',
    value: '845,200',
    change: 18.5,
    prefix: '$',
  },
  {
    id: 2,
    title: 'Utilidad Bruta',
    value: '382,450',
    change: 12.3,
    prefix: '$',
  },
  {
    id: 3,
    title: 'Utilidad Neta',
    value: '124,680',
    change: -8.4,
    prefix: '$',
  },
  {
    id: 4,
    title: 'Cash disponible',
    value: '245,300',
    change: -15.2,
    prefix: '$',
  },
  {
    id: 5,
    title: 'Cuentas por cobrar',
    value: '187,350',
    change: 22.1,
    prefix: '$',
  },
  {
    id: 6,
    title: 'Cuentas por pagar',
    value: '98,450',
    change: 5.8,
    prefix: '$',
  },
  {
    id: 7,
    title: 'Margen bruto',
    value: '45.2',
    change: -2.3,
    suffix: '%',
  },
  {
    id: 8,
    title: 'Margen neto',
    value: '14.8',
    change: -5.1,
    suffix: '%',
  },
]
// Revenue vs Expenses data (last 6 months)
export const revenueExpensesData = [
  {
    month: 'Feb',
    ingresos: 620000,
    gastos: 510000,
  },
  {
    month: 'Mar',
    ingresos: 680000,
    gastos: 540000,
  },
  {
    month: 'Abr',
    ingresos: 710000,
    gastos: 590000,
  },
  {
    month: 'May',
    ingresos: 760000,
    gastos: 620000,
  },
  {
    month: 'Jun',
    ingresos: 720000,
    gastos: 650000,
  },
  {
    month: 'Jul',
    ingresos: 845000,
    gastos: 720000,
  },
]
// Income Statement Data
export const incomeStatementData = {
  summary: [
    { name: 'Ingresos', value: 845200 },
    { name: 'Costo de Venta', value: 462750 },
    { name: 'Utilidad Bruta', value: 382450 },
    { name: 'Gastos Operativos', value: 230500 },
    { name: 'EBITDA', value: 151950 },
    { name: 'Depreciación/Amortización', value: 18200 },
    { name: 'Utilidad antes de impuestos', value: 133750 },
    { name: 'Impuestos', value: 40125 },
    { name: 'Utilidad neta', value: 93625 },
  ],
  expenses: [
    { name: 'Nómina', value: 125000 },
    { name: 'Marketing', value: 42000 },
    { name: 'Renta', value: 28000 },
    { name: 'Servicios', value: 12500 },
    { name: 'Otros', value: 23000 },
  ],
  margins: [
    { month: 'Feb', bruto: 42.1, neto: 13.2 },
    { month: 'Mar', bruto: 43.5, neto: 14.1 },
    { month: 'Abr', bruto: 44.8, neto: 14.5 },
    { month: 'May', bruto: 45.9, neto: 15.2 },
    { month: 'Jun', bruto: 47.1, neto: 16.8 },
    { month: 'Jul', bruto: 45.2, neto: 14.8 },
  ],
}
// Cash Flow Data
export const cashFlowData = {
  summary: [
    { name: 'Balance inicial', value: 289000 },
    { name: 'Entradas', value: 768000 },
    { name: 'Salidas', value: 811700 },
    { name: 'Balance final', value: 245300 },
  ],
  monthly: [
    { month: 'Feb', cashIn: 580000, cashOut: 540000, netCash: 40000 },
    { month: 'Mar', cashIn: 630000, cashOut: 590000, netCash: 40000 },
    { month: 'Abr', cashIn: 690000, cashOut: 650000, netCash: 40000 },
    { month: 'May', cashIn: 720000, cashOut: 680000, netCash: 40000 },
    { month: 'Jun', cashIn: 700000, cashOut: 740000, netCash: -40000 },
    { month: 'Jul', cashIn: 768000, cashOut: 811700, netCash: -43700 },
  ],
  waterfall: [
    { name: 'Inicial', value: 289000 },
    { name: 'Ventas', value: 710000 },
    { name: 'Otros ingresos', value: 58000 },
    { name: 'Costos', value: -462750 },
    { name: 'Gastos', value: -230500 },
    { name: 'Impuestos', value: -40125 },
    { name: 'Inversiones', value: -78325 },
    { name: 'Final', value: 245300 },
  ],
}
// Balance Sheet Data
export const balanceSheetData = {
  assets: [
    { name: 'Efectivo', value: 245300 },
    { name: 'Cuentas por cobrar', value: 187350 },
    { name: 'Inventario', value: 312500 },
    { name: 'Activos fijos', value: 685000 },
    { name: 'Otros activos', value: 98000 },
  ],
  liabilities: [
    { name: 'Cuentas por pagar', value: 98450 },
    { name: 'Deuda corto plazo', value: 120000 },
    { name: 'Deuda largo plazo', value: 350000 },
    { name: 'Otros pasivos', value: 75000 },
  ],
  equity: [
    { name: 'Capital social', value: 500000 },
    { name: 'Utilidades retenidas', value: 384700 },
  ],
  indicators: [
    { name: 'Razón circulante', value: 2.4 },
    { name: 'Prueba ácida', value: 1.4 },
    { name: 'Inventario en días', value: 60 },
    { name: 'Rotación AR (días)', value: 20 },
    { name: 'Rotación AP (días)', value: 19 },
  ],
  history: [
    { month: 'Feb', workingCapital: 480000 },
    { month: 'Mar', workingCapital: 510000 },
    { month: 'Abr', workingCapital: 535000 },
    { month: 'May', workingCapital: 560000 },
    { month: 'Jun', workingCapital: 545000 },
    { month: 'Jul', workingCapital: 526700 },
  ],
}
// Trends Data
export const trendsData = {
  sales: [
    { month: 'Ago 22', value: 520000 },
    { month: 'Sep 22', value: 550000 },
    { month: 'Oct 22', value: 580000 },
    { month: 'Nov 22', value: 590000 },
    { month: 'Dic 22', value: 610000 },
    { month: 'Ene 23', value: 600000 },
    { month: 'Feb 23', value: 620000 },
    { month: 'Mar 23', value: 680000 },
    { month: 'Abr 23', value: 710000 },
    { month: 'May 23', value: 760000 },
    { month: 'Jun 23', value: 720000 },
    { month: 'Jul 23', value: 845000 },
  ],
  cogs: [
    { month: 'Ago 22', value: 310000 },
    { month: 'Sep 22', value: 325000 },
    { month: 'Oct 22', value: 340000 },
    { month: 'Nov 22', value: 345000 },
    { month: 'Dic 22', value: 355000 },
    { month: 'Ene 23', value: 350000 },
    { month: 'Feb 23', value: 359000 },
    { month: 'Mar 23', value: 384000 },
    { month: 'Abr 23', value: 392000 },
    { month: 'May 23', value: 410000 },
    { month: 'Jun 23', value: 381000 },
    { month: 'Jul 23', value: 462750 },
  ],
  expenses: [
    { month: 'Ago 22', value: 165000 },
    { month: 'Sep 22', value: 170000 },
    { month: 'Oct 22', value: 172000 },
    { month: 'Nov 22', value: 175000 },
    { month: 'Dic 22', value: 178000 },
    { month: 'Ene 23', value: 176000 },
    { month: 'Feb 23', value: 180000 },
    { month: 'Mar 23', value: 185000 },
    { month: 'Abr 23', value: 195000 },
    { month: 'May 23', value: 205000 },
    { month: 'Jun 23', value: 220000 },
    { month: 'Jul 23', value: 230500 },
  ],
  cash: [
    { month: 'Ago 22', value: 220000 },
    { month: 'Sep 22', value: 235000 },
    { month: 'Oct 22', value: 250000 },
    { month: 'Nov 22', value: 265000 },
    { month: 'Dic 22', value: 270000 },
    { month: 'Ene 23', value: 275000 },
    { month: 'Feb 23', value: 280000 },
    { month: 'Mar 23', value: 320000 },
    { month: 'Abr 23', value: 360000 },
    { month: 'May 23', value: 400000 },
    { month: 'Jun 23', value: 360000 },
    { month: 'Jul 23', value: 245300 },
  ],
  comparisons: [
    { metric: 'Ventas', actual: 845000, prevMonth: 720000, prevYear: 580000 },
    {
      metric: 'Costo de Venta',
      actual: 462750,
      prevMonth: 381000,
      prevYear: 336000,
    },
    { metric: 'Gastos', actual: 230500, prevMonth: 220000, prevYear: 170000 },
    {
      metric: 'Utilidad Neta',
      actual: 93625,
      prevMonth: 84000,
      prevYear: 55000,
    },
    {
      metric: 'Cash disponible',
      actual: 245300,
      prevMonth: 360000,
      prevYear: 240000,
    },
  ],
}
// Insights and alerts
export const insightsData = [
  {
    id: 1,
    type: 'positive',
    message:
      'Tus ventas crecieron 18.5% este mes, superando la meta mensual de 10%.',
  },
  {
    id: 2,
    type: 'negative',
    message:
      'Tu flujo de caja es negativo por segundo mes consecutivo. Revisa tus gastos e inversiones.',
  },
  {
    id: 3,
    type: 'warning',
    message:
      'El inventario está 45% por encima del promedio histórico. Considera estrategias para reducirlo.',
  },
  {
    id: 4,
    type: 'info',
    message: 'Tus gastos en marketing aumentaron 34% vs. el mes anterior.',
  },
  {
    id: 5,
    type: 'warning',
    message:
      'Las cuentas por cobrar aumentaron 22.1%. Verifica la gestión de cobranza.',
  },
]
// Notifications data
export const notificationsData = [
  {
    id: 1,
    type: 'alert',
    title: 'Flujo de caja negativo',
    message:
      'Tu flujo de efectivo ha sido negativo por segundo mes consecutivo.',
    timestamp: 'Hace 2 horas',
    read: false,
    link: '/cash-flow',
  },
  {
    id: 2,
    type: 'warning',
    title: 'Inventario elevado',
    message: 'El inventario está 45% por encima del promedio histórico.',
    timestamp: 'Hace 5 horas',
    read: false,
    link: '/balance-sheet',
  },
  {
    id: 3,
    type: 'info',
    title: 'Reporte mensual disponible',
    message: 'El reporte financiero de julio 2023 está listo para descargar.',
    timestamp: 'Hace 1 día',
    read: false,
    link: '/',
  },
  {
    id: 4,
    type: 'success',
    title: 'Meta de ventas alcanzada',
    message: '¡Felicidades! Superaste la meta de ventas del mes en 18.5%.',
    timestamp: 'Hace 2 días',
    read: true,
    link: '/income-statement',
  },
  {
    id: 5,
    type: 'warning',
    title: 'Cuentas por cobrar elevadas',
    message: 'Las cuentas por cobrar aumentaron 22.1% este mes.',
    timestamp: 'Hace 3 días',
    read: true,
    link: '/balance-sheet',
  },
]
